import { render, staticRenderFns } from "./ProductSilder.vue?vue&type=template&id=042518e1&scoped=true&"
import script from "./ProductSilder.vue?vue&type=script&lang=js&"
export * from "./ProductSilder.vue?vue&type=script&lang=js&"
import style0 from "./ProductSilder.vue?vue&type=style&index=0&id=042518e1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "042518e1",
  null
  
)

export default component.exports